import { jsx } from "react/jsx-runtime";
import CallIcon from "@mui/icons-material/Call";
import { validateTidalLicense } from "../../base/index.js";
function Call(props) {
  return /* @__PURE__ */ jsx(
    CallIcon,
    {
      "data-testid": "Call",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Call",
      "data-tidal-icon-meta": "mail,contact,calendar"
    }
  );
}
Call.tidalIconMeta = {
  categories: "mail,contact,calendar",
  name: "Call"
};
validateTidalLicense();
export {
  Call
};
//# sourceMappingURL=Call.js.map
